import { round } from './number';
import { UnknownString } from '../constants';

export const formatCbh = (val) => {
  if (val === false || val === undefined) return UnknownString;
  if (val >= 0 && val <= 100) {
    return `${round(val / 10, 1)} m`;
  }

  return UnknownString;
};

export default {
  formatCbh,
};
